export const ARS_ID_FOR_EVENT = 'certs_access_request_history_button_id';
export const ARS_KEY = 'ACCESSTHROUGH';

export const ARS_API_SUFFIX_FOR_ROLE = 'getRoleRequestHistory';
export const ARS_API_SUFFIX_FOR_ACCOUNT = 'getAccountRequestHistory';
export const ARS_API_SUFFIX_FOR_ENTITLEMENT = 'getEntitlementRequestHistory';

export const REQUEST_TYPE_ROLE = 'Role';
export const REQUEST_TYPE_ACCOUNT = 'Account';
export const REQUEST_TYPE_ENTITLEMENT = 'Entitlement';

export const REQUEST_TYPE_VALUEKEY = {
  USER: '-4',
  ROLE: '-2',
  ACCOUNT: '0',
  ENTITLEMENT: 1, // any >= 0
};

export const DATE_FIELDS = [
  'requestDate',
  'approvedDate',
  'taskCreateDate',
  'taskUpdateDate',
];
export const MIN_COUNT_FOR_TOOLTIP_APPEAR = 2;
export const TOOLTIP_DELAY_IN_MS_TILE = 500;
